import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { AppTranslateModule } from '@core/app-translate.module';
import { DateModule } from '@shared/pipes/date/date.module';
import { FileSizeModule } from '@shared/pipes/file-size/file-size.module';
// Temporarily removed for Angular 19 compatibility
// import { MaterialFileInputModule } from 'ngx-material-file-input';

import { FormErrorComponent } from './form-error.component';

export const imports: NgModule['imports'] = [DateModule, FileSizeModule, MatInputModule, /* MaterialFileInputModule, */ ReactiveFormsModule];

@NgModule({
  declarations: [FormErrorComponent],
  imports: [...imports, CommonModule, AppTranslateModule],
  exports: [FormErrorComponent],
})
export class FormErrorModule {}
